import { getMetricValue } from '@vitalai/baseline-engine';
import type { MetricKey, NormalizedDailyMetrics } from '@vitalai/health-models';
import { calculateDailyScores } from '@vitalai/scoring-engine';
import { lastNDateKeys } from '@vitalai/shared';

export interface MetricPoint {
  date: string;
  value: number;
}

/** Ultimos `days` valores de una metrica, en orden cronologico, listos para un sparkline. */
export function getMetricSeries(
  historyByDate: Map<string, NormalizedDailyMetrics>,
  metric: MetricKey,
  endDateKey: string,
  days: number,
): MetricPoint[] {
  return lastNDateKeys(endDateKey, days)
    .map((date) => {
      const day = historyByDate.get(date);
      const value = day ? getMetricValue(day, metric) : null;
      return value === null || value === undefined ? null : { date, value };
    })
    .filter((point): point is MetricPoint => point !== null);
}

export interface ScoreHistoryPoint {
  date: string;
  readinessScore: number;
  sleepScore: number;
  recoveryScore: number;
  activityScore: number;
  nutritionScore: number;
}

/** Recalcula los scores diarios para los ultimos `days` dias, usado para graficas de tendencia. */
export function getScoreHistory(history: NormalizedDailyMetrics[], endDateKey: string, days: number): ScoreHistoryPoint[] {
  const availableDates = new Set(history.map((day) => day.date));
  return lastNDateKeys(endDateKey, days)
    .filter((date) => availableDates.has(date))
    .map((date) => {
      const scores = calculateDailyScores(history, date);
      return {
        date,
        readinessScore: scores.readinessScore,
        sleepScore: scores.sleepScore,
        recoveryScore: scores.recoveryScore,
        activityScore: scores.activityScore,
        nutritionScore: scores.nutritionScore,
      };
    });
}
